import { motion } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SelectEstado from "../../../../components/SelectEstado/SelectEstado";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../../contexts/Cor";
import FiltrosRedux from "../../../../contexts/Filtros.js";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import NomeTabelaRedux from "../../../../contexts/NomeTabela";
import TabelaRedux from "../../../../contexts/Tabela";
import DadosUsuarioRedux from "../../../../contexts/Usuario";
import {
	cadastraCidadeEstado,
	deleteCidadeEstadoPorId,
	editaCidadeEstadoPorId,
	getCidadeEstado,
	getCidadeEstadoPorId,
} from "../../../../services/ModuloGerenciador/CidadeEstado";
import { getRegras } from "../../../../services/ModuloGerenciador/Geral.ts";
import { getCidadeSearch } from "../../../../services/ModuloGerenciador/Search";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario";
import "./CidadeEstado.css";

function CidadeEstado() {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { multiplosFiltrosRedux, setMultiplosFiltrosRedux } = useContext(
		MultiplosFiltrosRedux
	);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const buscarCidadeEstado = async () => {
		setLoading(true);
		await getCidadeEstado(dadosUsuarioRedux.token)
			.then((result) => {
				setDadosTabela(result.data);
				setDadosTabelaCopia(result.data);
				setTabelaRedux({});
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (
			values.validatorCidade === "true" &&
			values.validatorEstado === "true"
		) {
			setLoading(true);
			await cadastraCidadeEstado(values, dadosUsuarioRedux.token)
				.then((result) => {
					if (result.status === 200) {
						buscarCidadeEstado();
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setLoading(false);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setOpenToastErro(true);
			setTextoErro("Todos os Campos são Obrigatorios");
		}
	};

	const title = useMemo(() => {
		if(editando) return "Detalhes de Cidade";
		if(telaCadastro) return "Cadastro de Cidade";
		return "Cidade/Estado";
	}, [editando, telaCadastro]);

	const editar = async () => {
		setLoading(true);
		await editaCidadeEstadoPorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					if (valuesPesquisa.pesquisa === undefined) {
						buscarCidadeEstado();
					} else {
						buscarSearch();
					}
					setTabelaRedux({});
					setTextoSucesso("Editado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarCidadeEstadoPorId = async () => {
		setLoading(true);
		await getCidadeEstadoPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarCidadeEstadoPorId = async () => {
		setLoading(true);
		await deleteCidadeEstadoPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarCidadeEstado();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValues((current) => ({
			...current,
			usuario: dadosUsuarioRedux.usuario.usuario,
		}));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarCidadeEstadoPorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarCidadeEstado();
		setValues((current) => ({ ...current, validatorCidade: "false" }));
		setValues((current) => ({ ...current, validatorEstado: "false" }));
	}, []);

	useEffect(() => {}, [telaCadastro, editando, loading]);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element === "Uso Comum") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra === "Uso Comum") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	const itensFiltro = [
		{
			nomeColuna: "Cidade",
			field: "Cidade",
		},
		{
			nomeColuna: "Estado",
			field: "Estado",
		},
		{
			nomeColuna: "Abreviação",
			field: "Abreviacao",
		},
	];

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopia);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getCidadeSearch(dadosUsuarioRedux.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const { filtrosRedux, setFiltrosRedux } = useContext(FiltrosRedux);

	const location = useLocation();

	useEffect(() => {
		setValuesPesquisa((current) => ({ ...current, item: undefined }));
		setValuesPesquisa((current) => ({ ...current, pesquisa: undefined }));
		setFiltrosRedux((current) => ({ ...current, item: undefined }));
		setFiltrosRedux((current) => ({ ...current, pesquisa: undefined }));
	}, [location.pathname]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<NavbarV3 title={title} selecionado="Cidade" />
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					<NavbarV3 title={title} selecionado="Cidade" />
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<div className="filtro-cliente-v2">
										<FiltroV2
											classe="div-filtrar-embarque-v2"
											classOption="select-options-cliente"
											itensFiltro={itensFiltro}
											valuesPesquisa={valuesPesquisa}
											setValuesPesquisa={setValuesPesquisa}
											buscarSearch={buscarSearch}
											limpar={limpar}
										/>
									</div>
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="idCidadeEstado"
										nomeClasse1="outer-wrapper-rota"
										nomeClasse2="table-wrapper-v2"
										colunas={dadosTabelaRedux.CidadeEstado}
										dados={dadosTabela}
									/>
									<div className="container-botoes-cliente">
										<div>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
										<div>
											<CustomButtonV2
												classCss="custom-button-user"
												classText="button-texto-user"
												titulo="Obter Usuário"
												cor="#FFFFFF"
												valor={values}
												onClick={() => {
													if (tabelaRedux.usuarioAlteracao) {
														setOpenUsuario(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									<div className="indicadores">
										<div className="texto-cadastro">
											<p className="indicador-emb">
												{"Dados de Cidade/Estado / "}
											</p>
											{editando ? (
												<p className="indicador-emb">
													{"Detalhes de Cidade/Estado"}
												</p>
											) : (
												<p className="indicador-emb">
													{"Cadastro de Cidade/Estado"}
												</p>
											)}
											<HeaderCadastro texto="" />
										</div>
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>	
										</div>
									</div>
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Cidade:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	cidade: e.target.value,
																}));
																setValues((current) => ({
																	...current,
																	validatorCidade: "true",
																}));
															}}
															value={values.cidade}
														/>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Estado:
														</p>
														<SelectEstado
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	estado: e.target.value,
																}));
																setValues((current) => ({
																	...current,
																	validatorEstado: "true",
																}));
															}}
															value={values.estado}
														/>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Abreviação:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															maxLength={10}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	abreviacao: e.target.value,
																}));
																setValues((current) => ({
																	...current,
																	validatorCidade: "true",
																}));
															}}
															value={values.abreviacao}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="botoes-embalagem">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
													setTelaCadastro(false);
													setEditando(false);
													setValues({});
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													cadastrar();
													if (
														values.validatorCidade === "true" &&
														values.validatorEstado === "true"
													) {
														setTelaCadastro(false);
														setValues({});
													}
												}}
											/>
										)}
										<CustomButtonV2
											classCss="custom-button-cancelar"
											classText="button-texto-cancelar"
											titulo="Cancelar"
											cor="#0946B8"
											valor={values}
											onClick={() => {
												setValues({});
												setTelaCadastro(false);
												setEditando(false);
												setTabelaRedux({});
											}}
										/>
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarCidadeEstadoPorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default CidadeEstado;
